import React, { useEffect, useMemo, useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import FeaturesView from "./components/FeaturesView";
import NotFoundPage from "./components/NotFoundPage";
import FlowsView from "./components/flows/FlowsView";
import ActionsView from "./components/actions/ActionsView";
import BreadcrumbsComponent from "./components/sharedComponents/BreadcrumbsComponent";
import Login from "./components/login";
import URLRedirection from "./components/ai-agents/URLRedirection";
import AgentChatWidget from "./components/ai-agents/AgentChatWidget";
import JobrockPublic from "./components/JobrockPublic";

const AppRoutes = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const checkAuthentication = () => {
      const cookies = document.cookie;
      setIsAuthenticated(cookies.includes("loginDetails"));
    };

    checkAuthentication();
  }, [navigate]);

  
  const shouldShowBreadcrumbs = useMemo(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const isAgentChatWidgetRoute = pathSegments.length >= 2;
    return isAuthenticated && !isAgentChatWidgetRoute;
  }, [location.pathname]);


  return (
    <>
      {shouldShowBreadcrumbs && <BreadcrumbsComponent />}
      <Routes>
        {/* Public Routes */}
        <Route path=":id" element={<URLRedirection />} />
        <Route path=":source/:uniqueId" element={<AgentChatWidget />} />
        <Route path=":source/:uniqueId/:version" element={<AgentChatWidget />} />
        <Route path="/jrpublic" element={<JobrockPublic />} />

        {/* Protected Routes */}
        <Route path="/" element={<Navigate to="/featuresView" />} />
        <Route path="/featuresView" element={isAuthenticated ? <FeaturesView /> : <Navigate to="/login" replace />} />
        <Route path="/flowsView" element={isAuthenticated ? <FlowsView /> : <Navigate to="/login" replace />} />
        <Route path="/actionsView" element={isAuthenticated ? <ActionsView /> : <Navigate to="/login" replace />} />

        {/* Login Route (should redirect to dashboard if already authenticated) */}
        <Route path="/login" element={isAuthenticated ? <Navigate to="/featuresView" replace /> : <Login />} />

        {/* Catch-all Route for NotFoundPage */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
